import './javascripts/_jquery';
import './javascripts/component-form.js';
